import React, { useState } from "react"
import { Container } from "react-bootstrap"
import ErrorIcon from "../../assets/images/signup-error.svg"
import FormBuilder from "../../components/common/FormBuilder/Form-Builder"
import "../../styles/component/popup-signup.scss"
import SVGIcon from "./SVGIcon"

function PopupUpload(props) {
  const [displayError, setDisplayError] = useState(false)
  const [success, setSuccess] = useState(false)
  const [disableButton, setDisableButton] = useState()

  const formdata = [
    {
      name: "firstname",
      type: "text",
      label: "Name",
      errorMessage: "Please enter a valid name",
    },
    {
      name: "email",
      type: "email",
      label: "Email address",
      errorMessage: "Please enter a valid email",
    },
    {
      name: "message",
      validateEmpty: "true",
      type: "textarea",
      label: "About Yourself",
      col: "10",
      errorMessage: "Please enter a valid message",
    },
    {
      name: "upload_file_link",
      type: "file",
      errorMessage: "Please upload a PDF file and size < 10MB",
      acceptFiletype: "application/pdf",
    },
  ]

  // const beforeSubmit = async items => {
  //   const formData = [...items]
  //   let file = document.getElementById("uploaded-file").files[0]
  //   let form = new FormData()
  //   form.append("fileUpload", file)
  //   setDisableButton(true)
  //   setDisplayError(false)
  //   let uploadData = null
  //   file &&
  //     (await fetch(`${process.env.GRAPHCMS_API_URL}/upload`, {
  //       method: "POST",
  //       headers: {
  //         Authorization: `Bearer ${process.env.GATSBY_GRAPHCMS_AUTH_TOKEN_SPOS}`,
  //       },
  //       body: form,
  //     })
  //       .then(response => {
  //         if (response.ok) {
  //           return response.json()
  //         } else {
  //           setDisableButton(false)
  //           setDisplayError(true)
  //         }
  //       })
  //       .then(res => {
  //         formData[3].value = res.url
  //         console.log(res, "res in fileupload")
  //         uploadData = items
  //         console.log(uploadData, "upload")
  //       })
  //       .catch(error => {
  //         // console.log(error)
  //         setDisplayError(true)
  //       }))
  //   return uploadData
  // }

  // const handleSubmit = items => {
  //   const formData = [...items]
  //   var fullname = formData[0].value.trim()
  //   if (fullname.includes(" ")) {
  //     //split Name if includes a empty space
  //     var fname = fullname.substr(0, fullname.indexOf(" "))
  //     var lname = fullname.substr(fullname.indexOf(" ") + 1)
  //     formData[0].value = fname
  //   } else {
  //     //else set Name as first_name
  //     fname = fullname
  //     lname = ""
  //   }
  //   formData[0].value = fname
  //   formData.push({ name: "lastname", value: lname })
  //   ///fetching file
  //   let file = document.getElementById("uploaded-file").files[0]
  //   let form = new FormData()
  //   form.append("fileUpload", file)
  //   setDisableButton(true)
  //   setDisplayError(false)
  //   file
  //     ? fetch(`${process.env.GRAPHCMS_API_URL}/upload`, {
  //         method: "POST",
  //         headers: {
  //           Authorization: `Bearer ${process.env.GATSBY_GRAPHCMS_AUTH_TOKEN_SPOS}`,
  //         },
  //         body: form,
  //       })
  //         .then(response => {
  //           if (response.ok) {
  //             return response.json()
  //           } else {
  //             setDisableButton(false)
  //             setDisplayError(true)
  //           }
  //         })
  //         .then(res => {
  //           formData[3].value = res.url
  //           handleFormSubmit(
  //             formData,
  //             process.env.HUBSPOT_TEMPLATE_UPLOAD_FORM_ENDPOINT,
  //             process.env.HUBSPOT_TEMPLATE_UPLOAD_FORM_ENDPOINT_URL,
  //             "TemplatePage - Superops",
  //             null,
  //             null,
  //             successCallback
  //           )
  //         })
  //         .catch(error => {
  //           // console.log(error)
  //           setDisplayError(true)
  //         })
  //     : handleFormSubmit(
  //         formData,
  //         process.env.HUBSPOT_TEMPLATE_UPLOAD_FORM_ENDPOINT,
  //         process.env.HUBSPOT_TEMPLATE_UPLOAD_FORM_ENDPOINT_URL,
  //         "TemplatePage - Superops",
  //         null,
  //         null,
  //         successCallback
  //       )
  // }
  // function successCallback() {
  //   setSuccess(true)
  // }

  const handleAfterSubmit = () => {
    setSuccess(true)
  }

  return (
    <div
      className="popup-signup"
      style={{ display: !props.visibility && "none" }}
    >
      <div
        className="wrap position-fixed"
        onClick={props.togglePopup}
        onKeyDown={props.togglePopup}
        role="button"
        tabIndex={0}
      >
        {/*  */}
      </div>

      <Container className="position-fixed">
        <div className="overflow">
          <div
            className="close position-absolute"
            onClick={props.togglePopup}
            onKeyDown={props.togglePopup}
            role="button"
            tabIndex={0}
          >
            <img
              src="https://us-west-2.graphassets.com/AsRMKMrtKTFW6TGbr4KgUz/zpyoXoSXRuWnSQ1KauLF"
              alt="close"
              height="24"
              width="24"
            />
          </div>

          <div className="forms">
            <span
              className="p16 info"
              style={{
                display: !displayError ? "block" : "none",
              }}
            >
              <center>{!success && <p> {props.title} </p>}</center>
            </span>
            <div
              className="api-error p14"
              style={{
                display: displayError ? "block" : "none",
              }}
            >
              <img
                src={ErrorIcon}
                height="10"
                width="10"
                className="position-relative"
                alt="img"
              />
              <p className="text-start mt16">
                Oops, we've hit a glitch. Try entering the details again.
              </p>
            </div>
            <div>
              {!success ? (
                <FormBuilder
                  formClassName="forms"
                  errorClassName="error-message"
                  inputErrorClassName="error-active"
                  data={formdata}
                  buttonText={!disableButton ? "SUBMIT" : "LOADING . . ."}
                  buttonClassName="primary"
                  IpStackData
                  // beforeSubmit={items => beforeSubmit(items)} //you get final data from here
                  endpoint={process.env.HUBSPOT_TEMPLATE_UPLOAD_FORM_ENDPOINT}
                  url={process.env.HUBSPOT_TEMPLATE_UPLOAD_FORM_ENDPOINT_URL}
                  formName="TemplatePage - Superops"
                  afterSubmit={handleAfterSubmit}
                  errorHandler={(d, res) => {
                    setDisplayError(true)
                  }}
                  fileUpload
                />
              ) : (
                <>
                  <div className="text-center mb24">
                    <SVGIcon name="upload-file-success" />

                    <h3 className="mb24 fw-bold">Uploaded!</h3>

                    <div className="mb50 text-grey">
                      <p className="p16 ">
                        {" "}
                        Thanks for uploading! We’ll have a look at the template
                        and get back to you. Keep sharing!{" "}
                      </p>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </Container>
    </div>
  )
}

export default PopupUpload
